<div aria-busy="true">
  @if (!widgetsOnly) {
    @if (!guestView) {
      <div
        class="mx-1 my-2 px-2 border-round-xl border-1 surface-border surface-0 flex align-items-center gap-2 overflow-hidden menu-bar">
        <p-skeleton width="7rem" height="3rem" borderRadius="0.75rem" />
        <p-skeleton shape="circle" size="2.5rem" />
        <p-skeleton
          class="hidden sm:block"
          width="8rem"
          height="2.25rem"
          borderRadius="2rem" />
        <p-skeleton
          class="hidden sm:block ml-auto"
          width="5.5rem"
          height="2.25rem"
          borderRadius="2rem" />
        <p-skeleton
          class="hidden sm:block"
          width="5rem"
          height="2.25rem"
          borderRadius="2rem" />
        <p-skeleton class="ml-auto sm:ml-0" shape="circle" size="2.5rem" />
        <p-skeleton shape="circle" size="3rem" />
      </div>
    }

    <div class="md:flex align-items-stretch gap-2 my-1 mx-1">
      @if (guestView) {
        <div
          class="flex-shrink-0 surface-0 py-2 px-3 border-round-xl flex align-items-center mb-2 md:mb-0">
          <p-skeleton width="7rem" height="3rem" borderRadius="0.75rem" />
        </div>
      }
      <div
        class="surface-0 py-2 px-3 border-round-xl flex flex-column justify-content-center gap-2 flex-grow-1 mb-2 md:mb-0 headline">
        <p-skeleton width="60%" height="1.5rem" />
        <p-skeleton width="10rem" height="0.9rem" />
      </div>
      <div
        class="hidden sm:flex align-items-center gap-3 flex-shrink-0 surface-0 py-2 px-3 border-round-xl">
        <p-skeleton shape="circle" size="2rem" />
        <div class="flex flex-column gap-2">
          <div class="flex justify-content-between">
            <p-skeleton width="2.5rem" height="0.8rem" />
            <p-skeleton width="5rem" height="0.8rem" />
            <p-skeleton width="2.5rem" height="0.8rem" />
          </div>
          <p-skeleton width="14rem" height="0.4rem" />
        </div>
      </div>
    </div>
  }

  <div class="widget-grid">
    @for (widget of widgets; track $index) {
      <div
        class="surface-card border-round-xl flex flex-column widget"
        [style.--w]="widget.w"
        [style.--h]="widget.h"
        [style.animation-delay]="$index * 60 + 'ms'">
        <div class="px-2 py-2">
          <p-skeleton width="9rem" height="0.9rem" />
        </div>
        <div class="flex-1 flex flex-column px-3 pb-3 min-h-0">
          @switch (widget.kind) {
            @case ('map') {
              <p-skeleton class="flex-1" height="100%" borderRadius="0.75rem" />
            }
            @case ('bars') {
              <div class="flex-1 flex align-items-end gap-2 min-h-0">
                @for (bar of widget.bars; track $index) {
                  <p-skeleton
                    class="flex-1 h-full flex align-items-end"
                    width="100%"
                    [height]="bar + '%'"
                    borderRadius="0.375rem 0.375rem 0 0" />
                }
              </div>
              <p-skeleton styleClass="mt-2" width="100%" height="0.25rem" />
            }
            @case ('rows') {
              <div class="flex-1 flex flex-column justify-content-around">
                @for (row of rows; track $index) {
                  <div class="flex align-items-center gap-3">
                    <div class="flex-1">
                      <p-skeleton [width]="row + '%'" height="0.8rem" />
                    </div>
                    <p-skeleton width="3rem" height="0.8rem" />
                  </div>
                }
              </div>
            }
            @case ('kpi') {
              <div
                class="flex-1 flex flex-column justify-content-center align-items-center gap-3">
                <p-skeleton width="8rem" height="2.75rem" />
                <p-skeleton width="11rem" height="0.8rem" />
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
